<mat-dialog-content>
   <h1>{{title | translate}}</h1>
   <p> {{confirmationText | translate}} </p>
</mat-dialog-content>

<mat-dialog-actions>
   <div fxFlex></div>
   <button mat-raised-button [mat-dialog-close]="false">{{deniedText|translate}}</button>
   <button mat-stroked-button color="warn" [mat-dialog-close]="true">{{confirmText|translate}}</button>
</mat-dialog-actions>